import {string} from 'prop-types';

const BirthDateResourceType = {
  label: string,
};

export default BirthDateResourceType;
